import store from "@/store"
import { LiveWinnerType } from "@/store/types"
import { DefaultEventsMap } from "@socket.io/component-emitter"
import { Socket } from "socket.io-client"

export class GlobalSocketService {
  public store = store

  private onTotalBetsUpdated = this.totalBetsUpdated.bind(this)
  private onLiveWinnerAdded = this.addLiveWinner.bind(this)

  constructor(public socket: Socket<DefaultEventsMap, DefaultEventsMap>) {
    this.handleEvents()
  }

  handleEvents() {
    this.socket.on("statistic:updated", this.onTotalBetsUpdated)
    this.socket.on("live-winners:add", this.onLiveWinnerAdded)
  }

  destroy() {
    this.socket.off("statistic:updated", this.onTotalBetsUpdated)
    this.socket.off("live-winners:add", this.onLiveWinnerAdded)
  }

  totalBetsUpdated(data: { key: string; count: number }) {
    this.store.commit(`global/UPDATE_STATISTIC`, data)
  }

  addLiveWinner(data: LiveWinnerType) {
    this.store.commit(`global/ADD_LIVE_WINNER`, data)
  }
}
